module.exports = __webpack_public_path__ + "static/paper-d47ea9a41234bb1f01e6479820c9a29c.webp";